const FETCH_PENDING = "ACTIONS_PERMISSIONS_FETCH_PENDING";
const FETCH_SUCCESS = "ACTIONS_PERMISSIONS_FETCH_SUCCESS";
const FETCH_ERROR = "ACTIONS_PERMISSIONS_FETCH_ERROR";

const FETCH_ALL_PENDING = "ACTIONS_PERMISSIONS_FETCH_ALL_PENDING";
const FETCH_ALL_SUCCESS = "ACTIONS_PERMISSIONS_FETCH_ALL_SUCCESS";
const FETCH_ALL_ERROR = "ACTIONS_PERMISSIONS_FETCH_ALL_ERROR";

const EDIT_PENDING = "ACTIONS_PERMISSIONS_EDIT_PENDING";
const EDIT_DONE = "ACTIONS_PERMISSIONS_EDIT_DONE";

const SET_FILTER = "ACTIONS_PERMISSIONS_SET_FILTERS";

export default {
  FETCH_PENDING,
  FETCH_SUCCESS,
  FETCH_ERROR,
  FETCH_ALL_PENDING,
  FETCH_ALL_SUCCESS,
  FETCH_ALL_ERROR,
  EDIT_PENDING,
  EDIT_DONE,
  SET_FILTER,
};
